import type { QuantitySelectionProps } from '../QuantitySelection.client';

type GetValidQuantityPropsDefaults = {
  currentQuantity: number;
  step: NonNullable<QuantitySelectionProps['step']>;
};

export type GetValidQuantityProps =
  | (GetValidQuantityPropsDefaults & {
      type: 'initial';
      max: NonNullable<QuantitySelectionProps['max']>;
      min: NonNullable<QuantitySelectionProps['min']>;
    })
  | (GetValidQuantityPropsDefaults & {
      type: 'increase';
      max: NonNullable<QuantitySelectionProps['max']>;
    })
  | (GetValidQuantityPropsDefaults & {
      type: 'decrease';
      min: NonNullable<QuantitySelectionProps['min']>;
    });

export const getValidQuantity = (props: GetValidQuantityProps): number => {
  switch (props.type) {
    case 'initial':
      if (props.currentQuantity < props.min) {
        return props.min;
      }
      if (props.currentQuantity > props.max) {
        return props.max;
      }
      return props.currentQuantity;
    case 'increase':
      if (props.currentQuantity + props.step > props.max) {
        return props.max;
      }
      return props.currentQuantity + props.step;
    case 'decrease':
      if (props.currentQuantity - props.step < props.min) {
        return props.min;
      }
      return props.currentQuantity - props.step;
    default:
      throw new Error('Please use a correct type.');
  }
};
